/**
 * Route Preloader
 * Preloads route modules on hover/focus for instant navigation
 */

// Map of route paths to their lazy-loaded components
const routeModules: Record<string, () => Promise<any>> = {
  "/": () => import("../pages/Index"),
  "/auth": () => import("../pages/Auth"),
  "/reset-password": () => import("../pages/ResetPassword"),
  "/onboarding": () => import("../pages/Onboarding"),
  "/dashboard": () => import("../pages/Dashboard"),
  "/matches": () => import("../pages/Matches"),
  "/saved-jobs": () => import("../pages/SavedJobs"),
  "/saved": () => import("../pages/SavedJobs"),
  "/applications": () => import("../pages/Applications"),
  "/settings": () => import("../pages/Settings"),
  "/privacy": () => import("../pages/Privacy"),
  "/terms": () => import("../pages/Terms"),
  "/post-assignment": () => import("../pages/PostAssignment"),
  "/create-profile": () => import("../pages/CreateFreelancerProfile"),
  "/freelancers": () => import("../pages/Freelancers"),
  "/admin/learning": () => import("../pages/AdminLearning"),
  "/admin/alerts": () => import("../pages/AdminAlerts"),
};

// Cache to prevent duplicate preloads
const preloadCache = new Set<string>();

/**
 * Preload a route module on hover/focus
 * This starts loading the JavaScript bundle before the user clicks
 */
export const preloadRoute = (path: string) => {
  // Normalize path
  const normalizedPath = path.split("?")[0]; // Remove query params
  
  // Check if already preloaded
  if (preloadCache.has(normalizedPath)) {
    return;
  }

  // Find matching route module
  const moduleLoader = routeModules[normalizedPath];
  if (moduleLoader) {
    preloadCache.add(normalizedPath);
    // Start loading the module (don't await - fire and forget)
    moduleLoader().catch(() => {
      // Silently handle errors - preloading is optional
      preloadCache.delete(normalizedPath);
    });
  }
};

/**
 * Preload multiple routes at once (useful for critical paths)
 */
export const preloadRoutes = (paths: string[]) => {
  paths.forEach(preloadRoute);
};
